import { SET_MQTT_CONNECTION } from '../constants/MQTTConstants';

const initialState = {
  connection: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_MQTT_CONNECTION: {
      return {
        ...state,
        connection: action.payload,
      };
    }

    default:
      return state;
  }
}
